module.exports = __webpack_public_path__ + "img/img_nav_notify.be7e461e.svg";